export default __webpack_public_path__ + "static/media/car.f587eff9.jpg";